<div class="header relative p-3">
  <div class="title text-center text-lg">Select Selfie</div>
  <button
    type="button"
    class="close absolute top-[50%] right-3 -translate-y-[50%]"
    (click)="onCloseModal()">
    <fa-icon [icon]="faTimes"></fa-icon>
  </button>
</div>
<div class="h-[400px] space-y-3 overflow-y-auto p-3">
  <div class="grid grid-cols-3 items-center gap-2">
    <div class="relative" *ngFor="let selfie of selfies">
      <img
        [src]="selfie.path"
        (click)="onSelectSelfie(selfie)"
        class="w-full cursor-pointer object-cover" />
      <div
        class="absolute right-2 top-1 cursor-pointer"
        (click)="deleteSelfie(selfie)">
        <fa-icon class="stroke-white" [icon]="faTimes"></fa-icon>
      </div>
    </div>
  </div>

  <div class="empty-items-text" *ngIf="!selfies">
    <p class="text-center text-sm text-primary-darkest">
      Dont have any photo to use
    </p>
  </div>
</div>
